<mat-tab-group class="custom-mat-tab" *ngIf="survey && survey.dataSections.length"
               (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">
  <mat-tab *ngFor="let section of survey.dataSections; let i = index" label="{{section.header}}">
    <ng-template mat-tab-label>
      <div class="custom-tab-header flex flex-row justify-start items-center">
        <div class="flex flex-col justify-start items-center">
          <div class="header">{{section.header}}</div>
          <div class="tool-name">{{section.toolName}}</div>

        </div>

      </div>
    </ng-template>
    <div *ngIf="i === selectedFieldSectionIndex" class="content pos-relative m-30 flex flex-col flex flex-col">
      <div *ngIf="section.config.Editor=='EntitySelectorComponent'" class="keno-grid-container">
        <particle-entity-selector [filterId]="section.config.EXECUTION_ID"
                                  [endpointName]="section.config.EndpointName"
                                  [filterTemplateId]="section.config.FilterTemplateId"
                                  [invalidateSubject]="invalidateSubjectEntityChart">
        </particle-entity-selector>
      </div>
      <div *ngIf="section.config.Editor=='TransactionSelectorComponent'" class="keno-grid-container">
        <particle-transaction-selector [filterId]="section.config.EXECUTION_ID"
                                       [invalidateSubject]="invalidateSubjectTransaction">
        </particle-transaction-selector>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
